const MODULE_NAME = 'InstrumentationsModule';

export const ADD_INSTRUMENTATION = `${MODULE_NAME}/ADD_INSTRUMENTATION`;
export const FETCH_INSTRUMENTATIONS = `${MODULE_NAME}/FETCH_INSTRUMENTATIONS`;
export const FETCH_ALL_INSTRUMENTATIONS_BY_SITE = `${MODULE_NAME}/FETCH_ALL_INSTRUMENTATIONS_BY_SITE`;
export const DELETE_INSTRUMENTATION = `${MODULE_NAME}/DELETE_INSTRUMENTATION`;
export const UPDATE_INSTRUMENTATION = `${MODULE_NAME}/UPDATE_INSTRUMENTATION`;
export const LINK_INSTRUMENTATION_TASK = `${MODULE_NAME}/LINK_INSTRUMENTATION_TASK`;
export const FETCH_INSTRUMENTATION_TASKS = `${MODULE_NAME}/FETCH_INSTRUMENTATION_TASKS`;
export const FETCH_INSTRUMENTATION_HISTORY = `${MODULE_NAME}/FETCH_INSTRUMENTATION_HISTORY`;
export const FETCH_INSTRUMENTATION_JOB_HISTORY = `${MODULE_NAME}/FETCH_INSTRUMENTATION_JOB_HISTORY`;
